import ConsoleApi from "apps/console/enums/consoleApi";
import { useGetApiData } from "shared/datalayer";
import { ApiClient } from "shared/types/ApiClient";

export function useGetClientDetails(clientId: string) {
  return useGetApiData<ApiClient>(
    ConsoleApi.GET_CLIENT_DETAILS,
    { pathParams: { clientId } },
    { enabled: Boolean(clientId) }
  );
}
